import type { Route } from '!/router'
import * as initial from '~/routes/search/initial'
import * as results from '~/routes/search/results'
import * as root from '~/routes/search/root'

export const route: Route = {
  children: [
    {
      path: '',
      component: [initial.Title, initial.SearchPage],
      init: root.model.init,
      left: initial.model.left,
    },
    {
      path: '/:contentType', // ContentType is for searching by tab that was removed (and that will be added again in future)
      component: [results.Title, results.SearchResultsPage],
      init: root.model.initSearchResultsPage,
      left: results.model.left,
    },
  ],
}
